import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import IndustryAndCompanyPicker from '../Component/IndustryAndCompanyPicker';
import TargetOverview from '../Component/TargetOverview';
import { getPerformanceDataAction } from '../action';
import BarGraphSalesAnalysis from '../Component/BarGraphSalesAnalysis';
import NetworkSales from '../Component/NetworkSales';
import OrderStatusSummaryCard from '../Component/OrderStatusSummaryCard';
import SalesAnalysis from '../Component/SalesAnalysis';
import NetworkOverview from '../Component/NetworkOverview';
import { ErrorOutline } from '@mui/icons-material';

const MyPerformance = () => {
  const dispatch = useDispatch();

  const [performanceData, setPerformanceData] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const { company_details } = useSelector((state) => {
    return {
      company_details: state.reportReducer.company_details,
    };
  });

  const getPerformanceData = async () => {
    setLoading(true);
    const payload = {
      manufacturer_id: company_details?.id,
    };
    const { data, error, message } = await getPerformanceDataAction(payload);
    if (!error) {
      setPerformanceData(data);
      dispatch({
        type: 'SET_NETWORK_DATA',
        data: data?.network_sales,
      });
      setLoading(false);
    } else {
      setLoading(false);
      return toast.error(message);
    }
  };

  useEffect(() => {
    if (company_details && company_details.id) {
      getPerformanceData();
    }
  }, [company_details]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <IndustryAndCompanyPicker />
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress sx={{ alignSelf: 'center' }} />
        </div>
      ) : performanceData ? (
        <>
          <Grid
            container
            spacing={2}
            mb={3}
          >
            {performanceData.target_report && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
              >
                <TargetOverview targetData={performanceData?.target_report} />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
            >
              <SalesAnalysis
                Value='month'
                data={
                  performanceData?.month_wise_sales_report?.sales_per_month
                }
                title={
                  performanceData?.month_wise_sales_report
                    ?.section_header_display_title
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
            >
              <SalesAnalysis
                Value='year'
                data={
                  performanceData?.year_wise_sales_report
                    ?.sales_per_financial_year
                }
                title={
                  performanceData?.year_wise_sales_report
                    ?.section_header_display_title
                }
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mb={3}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
            >
              <NetworkSales
                networkSalesReport={performanceData?.network_sales_report}
              />
            </Grid>
            {performanceData?.po_quantity_by_status && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
              >
                <OrderStatusSummaryCard
                  statuses={performanceData?.po_quantity_by_status}
                />
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
            >
              <OrderStatusSummaryCard
                statuses={performanceData?.order_quantity_by_status}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            alignItems='stretch'
          >
            <Grid
              item
              xs={12}
              mb={3}
            >
              <BarGraphSalesAnalysis
                analysisData={performanceData?.month_wise_sales_chart}
              />
            </Grid>
            <Grid
              item
              xs={12}
              mb={3}
            >
              <NetworkOverview data={performanceData?.network_sales} />
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={{ height: '50%', minHeight: 100 }}
        >
          <Box textAlign='center'>
            <ErrorOutline sx={{ fontSize: 60, color: '#B2B5C4' }} />
            <Typography
              sx={{ fontSize: 16, fontWeight: 600, color: '#8E92A8', mt: 1 }}
            >
              No Performance Data available.
            </Typography>
          </Box>
        </Grid>
      )}
    </Box>
  );
};

export default MyPerformance;
